import Svg, { Path } from 'react-native-svg'

export const EditIcon = ({ height = 16, width = 16, color = '#9EB5FA' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M13 3a2.36 2.36 0 0 0-3.333 0l-.194.193 3.334 3.333.193-.193A2.36 2.36 0 0 0 13 3ZM3.7 9a2 2 0 0 0-.507.866L2.527 12.3a1 1 0 0 0 1.206 1.206l2.434-.7a2 2 0 0 0 .866-.506l4.827-4.827L8.527 4.14 3.7 9Z"
      />
    </Svg>
  )
}
